import React from 'react';
import { Button, Typography } from 'antd';

const { Title, Text } = Typography;

const WelcomeComponent = () => {
  const handleClick = () => {
    window.open('https://api.whatsapp.com/send/?phone=5511987474777&text=Ol%C3%A1%21+Gostaria+de+saber+sobre+o+mare+ia&type=phone_number&app_absent=0', '_blank');
  };

  return (
    <div style={{ 
      padding: '20px', 
      textAlign: 'center', 
      border: '1px solid #f0f0f0', 
      borderRadius: '5px', 
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      maxWidth: '600px',
      margin: '0 auto'
    }}>
      <div style={{ 
        fontSize: '40px', 
        marginBottom: '16px',
        background: 'linear-gradient(45deg, #008CBA, #1890ff)',
        borderRadius: '50%',
        width: '80px',
        height: '80px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        🌊
      </div>
      
      <Title level={2} style={{ margin: '0 0 16px 0', color: '#1890ff' }}>
        Bem vindo a bordo do Maré IA!
      </Title>
      
      <Text style={{ 
        marginBottom: '20px', 
        display: 'block',
        fontSize: '16px',
        lineHeight: '1.6'
      }}>
        Sou um Agente de Inteligência Artificial criado para auxiliar você no Monitoramento Automático de Rotas e Embarques.
      </Text>
      
      <Text style={{ 
        marginBottom: '24px', 
        display: 'block',
        fontSize: '14px',
        color: '#666'
      }}>
        Caso tenha interesse, clique em "Quero uma Demo!"
      </Text>
      
      <Button 
        type="primary" 
        size="large" 
        onClick={handleClick} 
        style={{ 
          backgroundColor: '#1890ff', 
          borderColor: '#1890ff',
          height: '48px',
          fontSize: '16px',
          fontWeight: 'bold',
          borderRadius: '6px',
          boxShadow: '0 2px 4px rgba(24, 144, 255, 0.3)'
        }}
      >
        Quero uma Demo!
      </Button>
    </div>
  );
};

export default WelcomeComponent;
